import { colorPallete } from "@timhortons/common/src/assets/styles/colors";
import { IconNames } from "@timhortons/common/src/components/atoms/icon";
import { Text, TextSize, FontWeight } from "@timhortons/common/src/components/atoms/text";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet, View } from "react-native";
import Icon from "@timhortons/common/src/components/atoms/icon";

export interface IContactUsProps {}

export function ContactUs(props: IContactUsProps) {
  const { t } = useTranslation("contactUs");
  return (
    <View style={styles.masterWrapper}>
      <View style={styles.headerWrapper}>
        <Text
          testId="contactUsHeader"
          fontWeight={FontWeight.AutoGraphRegular}
          textSize={TextSize.ExtraLarge}
        >
          {t("contactUsHeader")}
        </Text>
        <Text
          textStyle={styles.subText}
          testId="contactUsSubText"
          fontWeight={FontWeight.Bold}
          textSize={TextSize.ExtremeLarge}
        >
          {t("contactUsSubText")}
        </Text>
      </View>
      <View style={styles.infoWrapper}>
        <View style={[styles.infoBox, { marginRight: 42 }]}>
          <View style={styles.iconWrapper}>
            <Icon name={IconNames.call} color={colorPallete.black2} size={24} />
          </View>
          <View style={styles.infoTextWrapper}>
            <Text
              testId="contactUsHeader"
              fontWeight={FontWeight.SemiBold}
              textSize={TextSize.Medium}
            >
              {t("callUs")}
            </Text>
            <Text
              testId="contactUsHeader"
              fontWeight={FontWeight.Regular}
              textSize={TextSize.ExtraRegular}
            >
              {t("phNo")}
            </Text>
          </View>
        </View>
        <View style={styles.infoBox}>
          <View style={styles.iconWrapper}>
            <Icon name={IconNames.mail} color={colorPallete.black2} size={24} />
          </View>
          <View style={styles.infoTextWrapper}>
            <Text
              testId="contactUsHeader"
              fontWeight={FontWeight.SemiBold}
              textSize={TextSize.Medium}
            >
              {t("write")}
            </Text>
            <Text
              testId="contactUsHeader"
              fontWeight={FontWeight.Regular}
              textSize={TextSize.ExtraRegular}
            >
              {t("email")}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  masterWrapper: {
    flex: 1,
    width: "100%",
    height: "100%"
  },
  headerWrapper: {
    backgroundColor: colorPallete.donutCream,
    maxHeight: "fit-content",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 36
  },
  subText: {
    marginTop: 12
  },
  iconWrapper: {
    maxWidth: 60,
    minWidth: 60,
    minHeight: 60,
    borderRadius: 30,
    backgroundColor: colorPallete.grey20,
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 24
  },
  infoWrapper: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 42
  },
  infoBox: {
    borderWidth: 1,
    borderRadius: 8,
    borderColor: colorPallete.grey7,
    padding: 20,
    flexDirection: "row",
    alignItems: "center",
    minWidth: 327
  },
  infoTextWrapper: {}
});
